import {produce} from "immer";
import {SET_DRAWER_VISIBILITY, SET_TAB} from './constant';
import React from "react";
import {ProviderType} from "../../../__generated__/graphql/types";

export enum ComplianceManagerTab {
    ISN="ISN",
    VERIFLYT="VERIFLYT",
    ICAN="ICAN",
    OVERALL="OVERALL"
}

export function mapProviderTypeToTab(type: ProviderType): ComplianceManagerTab | null {
    switch (type){
        case ProviderType.ISN:
            return ComplianceManagerTab.ISN;
        case ProviderType.VERIFLYT:
            return ComplianceManagerTab.VERIFLYT;
        case ProviderType.ICAN:
            return ComplianceManagerTab.ICAN;
        default:
            return null;
    }
}

export const DefaultState = {
    currentTab: ComplianceManagerTab.OVERALL,
    drawers: {
        overridePanel: {
            visible: false
        }
    }
}

export type State = typeof DefaultState;

export type Action = {
    type: typeof SET_TAB,
    payload: ComplianceManagerTab
} | {
    type: typeof SET_DRAWER_VISIBILITY,
    payload: {
        drawerType: keyof State['drawers'],
        visible: boolean
    }
}

export const Reducer: React.Reducer<State, Action> = (state, action) => produce(state, (draft) => {
    switch (action.type){
        case SET_TAB:
            draft.currentTab = action.payload;
            break;
        case SET_DRAWER_VISIBILITY:
            draft.drawers[action.payload.drawerType].visible = action.payload.visible;
            break;
    }
})